import './install-prompt.scss';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  dismissInstall,
  isInstallDismissed,
  isIos,
  isStandalone,
  promptInstall,
  useCanInstall
} from '@/shared/services/pwa-install';
import { Button } from '@/shared/ui';

/**
 * Предложение установить оболочку как PWA. Chromium (есть `beforeinstallprompt`) → кнопка с
 * нативным диалогом установки; iOS → инструкция (программной установки нет). Не показывается,
 * если уже standalone или отказ ещё «свежий». Размещается на Home.
 */
const InstallPrompt: React.FC = () => {
  const { t } = useTranslation();
  const canInstall = useCanInstall();
  const ios = isIos();

  const [hidden, setHidden] = useState(
    () => isStandalone() || isInstallDismissed()
  );

  // Скрываем, если уже установлено/закрыто, либо нечего предложить (не Chromium и не iOS).
  if (hidden || isStandalone()) return null;
  if (!canInstall && !ios) return null;

  const close = () => {
    dismissInstall();
    setHidden(true);
  };

  const install = async () => {
    const outcome = await promptInstall();
    if (outcome) setHidden(true);
  };

  return (
    <div className="install-prompt">
      <div className="install-prompt__text">
        <span className="install-prompt__title">{t('pwa.title')}</span>
        <span className="install-prompt__subtitle">
          {canInstall ? t('pwa.subtitle') : t('pwa.iosHint')}
        </span>
      </div>

      <div className="install-prompt__actions">
        <button
          type="button"
          className="install-prompt__dismiss"
          onClick={close}
        >
          {t('pwa.dismiss')}
        </button>
        {canInstall ? (
          <Button
            type="button"
            variant="filled-purple"
            onClick={() => void install()}
          >
            {t('pwa.install')}
          </Button>
        ) : null}
      </div>
    </div>
  );
};

export default InstallPrompt;
